module.exports = __webpack_public_path__ + "img/eliminar.a9f4376e.png";